import React from "react";
import TopSection from "./components/TopSection";
import CourseNav from "./components/CourseNav";
import Overview from "./components/Overview";
import KeyFocus from "./components/KeyFocus";
import Outcomes from "./components/Outcomes";
import Modules from "./components/Modules";
import ProgrammeFormat from "./components/ProgrammeFormat";
import Cost from "./components/Cost";
import ContactUs from "./components/ContactUs";
import ApplyNowForm from "./components/ApplyNowForm";

const ExecutiveSummerSchool = () => {
  return (
    <div>
      <TopSection />
      <CourseNav />
      <section id="overview" className=" scroll-mt-20 md:scroll-m-36">
        <Overview />
      </section>

      <section id="keyFocus" className=" scroll-mt-20 md:scroll-m-36">
        <KeyFocus />
      </section>

      <section id="expectedOutcomes" className=" scroll-mt-20 md:scroll-m-36">
        <Outcomes />
      </section>

      <section id="modules" className=" scroll-mt-20 md:scroll-m-36">
        <Modules />
      </section>

      <section id="programmeFormat" className=" scroll-mt-20 md:scroll-m-36">
        <ProgrammeFormat />
      </section>

      <section id="cost" className=" scroll-mt-20 md:scroll-m-36">
        <Cost />
      </section>

      <section id="contactUs" className=" scroll-mt-20 md:scroll-m-36">
        <ContactUs />
      </section>
      <section id="applyNow" className=" scroll-mt-20 md:scroll-m-36">
        <ApplyNowForm />
      </section>
    </div>
  );
};

export default ExecutiveSummerSchool;
